const SearchSvg = (props) => {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      {...props}
    >
      <circle
        cx="11"
        cy="11"
        r="6"
        fill="#e4e4e4"
        fillOpacity="0.78"
        stroke="#d9d9d9"
        strokeWidth="1.2"
      />
      <path
        d="M20 20L17 17"
        stroke="#d9d9d9"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default SearchSvg
